import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107120Status: 'idle',
    startProcess107120Error: undefined as any,
    loadUserParamsProcess107120Status: 'idle',
    loadUserParamsProcess107120Error: undefined as any,

    process107120List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107120 = createAsyncThunk('process107120Slice/startProcess107120', async ({ process107120 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107120/`,
        prepareData(process107120),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107120Status } = getState().process107120Slice
        return startProcess107120Status !== 'pending'
    }
})

export const loadUserParamsProcess107120 = createAsyncThunk('process107120Slice/loadUserParamsProcess107120', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107120/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107120Status } = getState().process107120Slice
        return loadUserParamsProcess107120Status !== 'pending'
    }
})

const Process107120Slice = createSlice({
    name: 'process107120Slice',
    initialState,
    reducers: {
        resetstartProcess107120: (state) => {
            state.job = undefined
            state.startProcess107120Error = undefined
        },
        resetstartProcess107120Error: (state) => {
            state.startProcess107120Error = undefined
        },
        resetloadUserParamsProcess107120: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107120Error = undefined
        },
        resetloadUserParamsProcess107120Error: (state) => {
            state.loadUserParamsProcess107120Error = undefined
        },
        removeFromProcess107120ListById: (state, action) => {
            state.process107120List = state.process107120List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107120ListByIds: (state, action) => {
            state.process107120List = state.process107120List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107120List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107120Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107120List = []
            state.startProcess107120Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107120.pending, (state) => {
            state.startProcess107120Status = 'pending'
            state.startProcess107120Error = undefined
        })
        builder.addCase(startProcess107120.fulfilled, (state, action) => {
            state.startProcess107120Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107120.rejected, (state, action) => {
            state.startProcess107120Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107120Error = action.error.message
            } else {
                state.startProcess107120Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107120.pending, (state) => {
            state.loadUserParamsProcess107120Status = 'pending'
            state.loadUserParamsProcess107120Error = undefined
        })
        builder.addCase(loadUserParamsProcess107120.fulfilled, (state, action) => {
            state.loadUserParamsProcess107120Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107120.rejected, (state, action) => {
            state.loadUserParamsProcess107120Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107120Error = action.error.message
            } else {
                state.loadUserParamsProcess107120Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107120,
    resetstartProcess107120Error,
    resetloadUserParamsProcess107120,
    resetloadUserParamsProcess107120Error,
    removeFromProcess107120ListById,
    removeFromProcess107120ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107120Slice.actions
export default Process107120Slice.reducer
